<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="create-subscription-commission-agreement-modal">
    <div class="modal-dialog" role="document">
      <loading-spinner v-if="loading"></loading-spinner>

      <div v-else class="modal-content">
        <form @submit.prevent="submit">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">
                &times;
              </span>
            </button>

            <h4 class="modal-title">
              Create Subscription Commission Agreement
            </h4>
          </div>

          <div class="modal-body">
            <text-form-group
                v-model="data.commission"
                name="commission"
                label="Commission"
                :error="getError('commission')"
            ></text-form-group>

            <number-form-group
                v-model="data.interval_start"
                name="interval_start"
                label="Interval Start"
                :error="getError('interval_start')"
            ></number-form-group>

            <number-form-group
                v-model="data.interval_end"
                name="interval_end"
                label="Interval End"
                :error="getError('interval_end')"
            ></number-form-group>

            <select-form-group
                v-model="data.portal_id"
                name="portal"
                label="Portal"
                :error="getError('portal_id')"
                :options="portalOptions"
            ></select-form-group>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Close
            </button>

            <button type="submit" class="btn btn-black">
              <i class="fa fa-save"></i> Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import Errors from '@/mixins/Errors'
import LoadingSpinner from '@/components/Layout/LoadingSpinner'
import NumberFormGroup from '@/vendor/forms/FormGroups/Block/Number'
import SelectFormGroup from '@/vendor/forms/FormGroups/Block/Select'
import TextFormGroup from '@/vendor/forms/FormGroups/Block/Text'

export default {
  components: {LoadingSpinner, NumberFormGroup, SelectFormGroup, TextFormGroup},

  mixins: [Errors],

  props: {
    user: {
      required: true
    }
  },

  data() {
    return {
      data: {},

      loading: true,

      portals: null
    }
  },

  mounted() {
    this.load()

    this.listenForClose()
  },

  computed: {
    portalOptions() {
      return this.portals.map(portal => ({value: portal.id, label: portal.attributes.name}))
    }
  },

  methods: {
    load() {
      http.get('/api/v2/portals').then(response => {
        this.portals = response.data.data

        this.loading = false
      })
    },

    listenForClose() {
      $(this.$el).on('hidden.bs.modal', this.reset)
    },

    submit() {
      http.post('/api/v2/subscription-commission-agreements', {...this.data, user_id: this.user.id})
          .then(response => {
            notify.success('The subscription commission agreement was saved')

            this.$emit('created', response.data.data)

            $(this.$el).modal('hide')
          })
          .catch(this.catchValidationErrors)
    },

    reset() {
      this.errors = {}

      this.data = {}
    }
  }
}
</script>
